'use strict';
/** family: Card **/
var __assign =
	(this && this.__assign) ||
	function () {
		__assign =
			Object.assign ||
			function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s)
						if (Object.prototype.hasOwnProperty.call(s, p))
							t[p] = s[p];
				}
				return t;
			};
		return __assign.apply(this, arguments);
	};
var __rest =
	(this && this.__rest) ||
	function (s, e) {
		var t = {};
		for (var p in s)
			if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
				t[p] = s[p];
		if (s != null && typeof Object.getOwnPropertySymbols === 'function')
			for (
				var i = 0, p = Object.getOwnPropertySymbols(s);
				i < p.length;
				i++
			)
				if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
		return t;
	};
Object.defineProperty(exports, '__esModule', { value: true });
var classNames = require('classnames');
var React = require('react');
var CLASS_NAME = 'i-card__header__subtitle';
/**
 * The header subtitle subcomponent for a card.
 *
 * CardSubtitle should only be used inside CardHeader.
 */
var CardSubtitle = function (_a) {
	var children = _a.children,
		className = _a.className,
		restProps = __rest(_a, ['children', 'className']);
	return React.createElement(
		'div',
		__assign({ className: classNames(CLASS_NAME, className) }, restProps),
		children
	);
};
exports.CardSubtitle = CardSubtitle;
//# sourceMappingURL=CardSubtitle.js.map
